export enum PricingProfilePricingType {
  COSTING = 'costing',
  PRICING = 'pricing',
}

export enum PricingProfileType {
  BASE = 'base',
  DEFAULT = 'default',
  PROJECT = 'project',
}

export enum PricingProfileAccessActionType {
  EDIT_PRICING = 'edit_pricing',
}
